let addToCartForms = document.querySelectorAll('form[action="/cart/add"]')



// this give us an object with the name of the inputs as the key and the value as the value
let getData = form => Object.fromEntries(new FormData(form))
// expected output: Object {id: '39891069042999', quantity: '1', price: '£475.00'}

for (let index = 0; index < addToCartForms.length; index++) {
	addToCartForms[index].addEventListener('submit', e => {
		let data = getData(e.target)
		function gtag_report_conversion(url) {
			let callback = function () {
				if (typeof url != 'undefined') {
					window.location = url
				}
			}
			gtag('event', 'add_to_cart', { send_to: 'AW-327110317/E42GCLmZ0YcYEK2d_ZsB', value: data.price, currency: window.Shopify.currency.active, event_callback: callback })
			return false
		}
		gtag_report_conversion()
	})
}